<template>
  <div class="preLogin-wrap">
    <!--没有登录-->
    <van-overlay :show="true" v-if="!token">
      <div class="wrapper" :style="bgImgUrl">
        <img @click="handleLogin" class="img" :src="preImgUrl" />
      </div>
    </van-overlay>
    <!--登录后无电视源-->
    <div class="login" v-else>
      <img class="img" :src="loginUrl" />
      <div class="user">
        <van-divider>当前账号</van-divider>
        <div class="content">
          <van-image round width="1.5rem" height="1.5rem" :src="userInfo.avatar" />
          <span class="name">{{ userInfo.nick_name }}</span>
          <div class="account" @click="handleLogin">
            <img class="img" :src="chooseAccount" />
            <span class="title">切换账号</span>
          </div>
        </div>
      </div>
      <div class="active">
        <div>活动仅限腾讯/爱奇艺电视源参与</div>
        <span v-if="!source">{{ '如您已登录同一账号在电视端，请稍等或刷新重试' }}</span>
        <span v-else @click="handleActive">{{ '已登陆电视端，进入活动 >' }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PreLogin',
  props: {
    token: {
      type: String,
      default: ''
    },
    userInfo: {
      type: Object,
      default () {
        return {}
      }
    },
    source: {
      type: [String, Object]
    }
  },
  data () {
    return {
      preImgUrl: require('@/assets/images/sellCard/sellcard-preLogin.png'),
      loginUrl: require('@/assets/images/sellCard/login-desc.png'),
      chooseAccount: require('@/assets/images/sellCard/chooseAccount.png'),
      bgImgUrl: ''
    }
  },
  created () {
    const name = this.$route.name
    if (name === 'sellCard') {
      this.bgImgUrl = {
        background: `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0, 0.6)), url('${require('@/assets/images/sellCard/tencent-active.jpeg')}') no-repeat`,
        backgroundSize: '100%'
      }
    } else {
      this.bgImgUrl = {
        background: `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0, 0.6)), url('${require('@/assets/images/sellCard/yinheBg.jpg')}') no-repeat`,
        backgroundSize: '100%'
      }
    }
  },
  methods: {
    handleLogin () {
      this.$emit('handleLogin')
    },
    handleActive () {
      this.$emit('insertActive', this.source)
    }
  }
}
</script>
<style lang="stylus" scoped>
.preLogin-wrap
  background #EFEFEF
  .van-overlay
    background-color rgba(0, 0, 0, .5)
    .wrapper
      display flex
      justify-content center
      align-items center
      height 100%
      .img
        width 70%
  .login
    .img
      width 100%
      height 100%
    .user
      box-sizing border-box
      margin 10px 0
      padding 10px 0 10px 10px
      height 111px
      background #fff
      .van-divider
        width 40%
        margin 0 auto
        border-color #969695
        font-size 12px
      .content
        display flex
        align-items center
        .name
          display inline-block
          flex 1
          font-weight 900
          font-size 15px
          padding-left 20px
        .account
          position relative
          width 82px
          height 34px
          display flex
          align-items center
          justify-content center
          overflow hidden
          .img
            width 100%
          .title
            position absolute
            font-size 12px
            color #fff
            font-weight 400
    .active
      box-sizing border-box
      height 81px
      line-height 30px
      color #F18017
      font-size 14px
      text-align center
      padding-top 8px
</style>
